module.exports = __webpack_public_path__ + "img/review-popup-90@2x.f2362107.png";